import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { Row, Col, DatePicker, Select, Tabs, Table, Tag, Empty, Spin, Tooltip, message } from "antd";
import { ButtonItem, SelectEmpleadosItem, fmtFechaDia } from "../../../Components/Items";
import { COLOR_ESTATUS } from "./HistorialTrabajo";
import { descargarExcelProduccion, especieConDetalle, textoSemana } from "./exportarProduccionSemanal";

const { RangePicker } = DatePicker;
const { Option } = Select;
const { TabPane } = Tabs;

// Reporte semanal de produccion por persona: lo mismo que la "Libreta de produccion" del
// taller (una hoja por semana con una seccion por etapa y el resumen por persona, mas la
// hoja Resumen persona × semana), calculado de las asignaciones del tablero por persona.
class ReporteProduccionSemanal extends Component {
  state = {
    loading: false,
    datos: null,
    periodo: [moment().startOf("month"), moment()],
    etapasIds: [],
    empleadosIds: [],
    etapasOpciones: [],
    tab: "resumen",
  };

  componentDidMount() {
    this.consultarEtapas();
    this.consultar();
  }

  consultarEtapas = () => {
    axios
      .post("etapas/selectTodasEtapas", { empresaId: this.props.empresaId, valor: 3 }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ etapasOpciones: (res.data.etapas || []).filter((e) => e.controlPorPersona === true) });
        }
      })
      .catch(() => {});
  };

  consultar = () => {
    const [desde, hasta] = this.state.periodo || [];
    if (!desde || !hasta) {
      message.warning("Elige el periodo");
      return;
    }
    this.setState({ loading: true });
    axios
      .post(
        "asignacionesAgrupacion/reporteProduccionSemanal",
        {
          empresaId: this.props.empresaId,
          fechaInicio: desde.format("YYYY-MM-DD"),
          fechaFin: hasta.format("YYYY-MM-DD"),
          etapasIds: this.state.etapasIds,
          empleadosIds: this.state.empleadosIds,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ loading: false, datos: res.data, tab: "resumen" });
        } else {
          this.setState({ loading: false, datos: null });
          message.warning(res.data.message || "No se pudo generar el reporte");
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ loading: false, datos: null });
        message.error("Error al generar el reporte");
      });
  };

  descripcionFiltros() {
    const [desde, hasta] = this.state.periodo || [];
    const partes = [`Periodo ${desde?.format("DD/MM/YYYY")} al ${hasta?.format("DD/MM/YYYY")}`];
    if (this.state.etapasIds.length > 0) {
      const nombres = this.state.etapasOpciones
        .filter((e) => this.state.etapasIds.includes(e._id))
        .map((e) => e.nombre);
      partes.push(`Etapas: ${nombres.join(", ")}`);
    }
    if (this.state.empleadosIds.length > 0) partes.push(`${this.state.empleadosIds.length} persona(s) seleccionada(s)`);
    return partes.join(" · ");
  }

  descargarExcel = () => {
    const { datos, periodo } = this.state;
    if (!datos || datos.semanas.length === 0) {
      message.info("Primero consulta un periodo con información");
      return;
    }
    descargarExcelProduccion({
      datos,
      empresaNombre: this.props.empresaNombre,
      descripcionFiltros: this.descripcionFiltros(),
      desde: periodo[0].format("YYYY-MM-DD"),
      hasta: periodo[1].format("YYYY-MM-DD"),
    });
  };

  // ─── Semana ─────────────────────────────────────────────────────────────

  columnasSemana = [
    { title: "Persona", dataIndex: "empleadoNombre", key: "empleadoNombre", width: 170 },
    { title: "Número", dataIndex: "numero", key: "numero", width: 80 },
    { title: "Cliente", dataIndex: "clienteNombre", key: "clienteNombre" },
    { title: "Especie", key: "especie", render: (_, f) => especieConDetalle(f) },
    { title: "Cant.", dataIndex: "cantidad", key: "cantidad", align: "right", width: 60 },
    { title: "Inicio", dataIndex: "fechaInicio", key: "fechaInicio", width: 100, render: (f) => fmtFechaDia(f) },
    { title: "Término", dataIndex: "fechaTermino", key: "fechaTermino", width: 100, render: (f) => fmtFechaDia(f, "") },
    {
      title: "Días háb.",
      dataIndex: "diasHabiles",
      key: "diasHabiles",
      align: "right",
      width: 80,
      render: (dias, f) =>
        f.diasTranscurridos ? (
          <Tooltip title="Transcurridos al cierre de la semana: la pieza seguía en proceso">
            <span style={{ color: "#8c8c8c", fontStyle: "italic" }}>{dias}</span>
          </Tooltip>
        ) : (
          dias
        ),
    },
    {
      title: "Estatus",
      dataIndex: "estatusTexto",
      key: "estatusTexto",
      width: 110,
      render: (e) => <Tag color={COLOR_ESTATUS[e] || "default"}>{e}</Tag>,
    },
    { title: "Notas", dataIndex: "notas", key: "notas" },
  ];

  columnasResumenSemana = (etapaNombre) => [
    { title: etapaNombre, dataIndex: "nombre", key: "nombre" },
    { title: "Animales", dataIndex: "animales", key: "animales", align: "right" },
    { title: "Terminados", dataIndex: "terminados", key: "terminados", align: "right" },
  ];

  renderSeccion(seccion) {
    return (
      <div key={seccion.etapaId} style={{ marginBottom: 20 }}>
        <div style={{ fontSize: 15, fontWeight: "bold", color: "#005F6B", borderBottom: "2px solid #00BFD6", marginBottom: 8 }}>
          {seccion.etapaNombre.toUpperCase()}
        </div>
        <Row gutter={16}>
          <Col xs={24} xl={17}>
            <Table
              size="small"
              rowKey="_id"
              columns={this.columnasSemana}
              dataSource={seccion.filas}
              pagination={false}
              scroll={{ x: 1100 }}
              locale={{ emptyText: "Sin piezas en esta semana" }}
              summary={() =>
                seccion.filas.length > 0 ? (
                  <Table.Summary.Row>
                    <Table.Summary.Cell index={0} colSpan={4}>
                      <b>Total animales</b>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={4} align="right">
                      <b>{seccion.totalAnimales}</b>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={5} colSpan={5} />
                  </Table.Summary.Row>
                ) : null
              }
            />
          </Col>
          <Col xs={24} xl={7}>
            <Table
              size="small"
              rowKey={(p) => String(p.empleadoId)}
              title={() => <b>Resumen de la semana</b>}
              columns={this.columnasResumenSemana(seccion.etapaNombre)}
              dataSource={seccion.resumen}
              pagination={false}
              locale={{ emptyText: "—" }}
              summary={() =>
                seccion.resumen.length > 0 ? (
                  <Table.Summary.Row>
                    <Table.Summary.Cell index={0}>
                      <b>Total</b>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={1} align="right">
                      <b>{seccion.totalAnimales}</b>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={2} align="right">
                      <b>{seccion.totalTerminados}</b>
                    </Table.Summary.Cell>
                  </Table.Summary.Row>
                ) : null
              }
            />
          </Col>
        </Row>
      </div>
    );
  }

  // ─── Resumen persona × semana ───────────────────────────────────────────

  renderMatriz(etapa, semanas, { titulo, valor, tituloTotal, total }) {
    const columnas = [
      { title: "Persona", dataIndex: "nombre", key: "nombre", fixed: "left", width: 180 },
      ...semanas.map((s, i) => ({
        title: s.etiqueta,
        key: s.clave,
        align: "right",
        width: 90,
        render: (_, p) => valor(p, i) || "",
      })),
      { title: tituloTotal, key: "total", align: "right", width: 110, render: (_, p) => <b>{total(p)}</b> },
    ];
    return (
      <Table
        size="small"
        rowKey={(p) => String(p.empleadoId)}
        title={() => <b>{titulo}</b>}
        columns={columnas}
        dataSource={etapa.personas}
        pagination={false}
        scroll={{ x: 180 + semanas.length * 90 + 110 }}
        locale={{ emptyText: "Sin piezas en el periodo" }}
        summary={() =>
          etapa.personas.length > 0 ? (
            <Table.Summary.Row>
              <Table.Summary.Cell index={0}>
                <b>Total</b>
              </Table.Summary.Cell>
              {semanas.map((s, i) => (
                <Table.Summary.Cell key={s.clave} index={i + 1} align="right">
                  <b>{etapa.personas.reduce((t, p) => t + valor(p, i), 0)}</b>
                </Table.Summary.Cell>
              ))}
              <Table.Summary.Cell index={semanas.length + 1} align="right">
                <b>{etapa.personas.reduce((t, p) => t + total(p), 0)}</b>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          ) : null
        }
      />
    );
  }

  renderResumen() {
    const { datos } = this.state;
    return (
      <>
        {datos.resumen.map((etapa) => (
          <div key={etapa.etapaId} style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 15, fontWeight: "bold", color: "#005F6B", borderBottom: "2px solid #00BFD6", marginBottom: 8 }}>
              {etapa.etapaNombre.toUpperCase()}
            </div>
            <Row gutter={16}>
              <Col xs={24} xl={12}>
                {this.renderMatriz(etapa, datos.semanas, {
                  titulo: "Animales trabajados",
                  valor: (p, i) => p.porSemana[i]?.animales || 0,
                  tituloTotal: "Piezas distintas",
                  total: (p) => p.totalPiezas,
                })}
              </Col>
              <Col xs={24} xl={12}>
                {this.renderMatriz(etapa, datos.semanas, {
                  titulo: "Terminados",
                  valor: (p, i) => p.porSemana[i]?.terminados || 0,
                  tituloTotal: "Total",
                  total: (p) => p.totalTerminados,
                })}
              </Col>
            </Row>
          </div>
        ))}
        <div style={{ color: "#8c8c8c", fontSize: 12 }}>
          Una pieza que no se termina en la semana aparece también en la siguiente (como en la libreta), por eso
          "Piezas distintas" no es la suma de las semanas.
        </div>
      </>
    );
  }

  render() {
    const { datos } = this.state;
    return (
      <Spin spinning={this.state.loading}>
        <Row gutter={[12, 12]} align="middle" style={{ marginBottom: 12 }}>
          <Col>
            <RangePicker
              format="DD/MM/YYYY"
              value={this.state.periodo}
              allowClear={false}
              onChange={(periodo) => this.setState({ periodo })}
            />
          </Col>
          <Col flex="220px">
            <Select
              mode="multiple"
              allowClear
              style={{ width: "100%" }}
              placeholder="Todas las etapas"
              value={this.state.etapasIds}
              onChange={(etapasIds) => this.setState({ etapasIds })}
              maxTagCount="responsive"
            >
              {this.state.etapasOpciones.map((e) => (
                <Option key={e._id} value={e._id}>
                  {e.nombre}
                </Option>
              ))}
            </Select>
          </Col>
          <Col flex="260px">
            <SelectEmpleadosItem
              empresaId={this.props.empresaId}
              headersToken={this.props.headersToken}
              mode="multiple"
              width="100%"
              placeholder="Todas las personas"
              incluirBajas
              value={this.state.empleadosIds}
              onChange={(empleadosIds) => this.setState({ empleadosIds: empleadosIds || [] })}
            />
          </Col>
          <Col>
            <ButtonItem type="primary" onClick={this.consultar}>
              Consultar
            </ButtonItem>
          </Col>
          <Col>
            <ButtonItem verde onClick={this.descargarExcel}>
              Descargar Excel
            </ButtonItem>
          </Col>
        </Row>

        {!datos || datos.semanas.length === 0 || datos.etapas.length === 0 ? (
          <Empty
            style={{ padding: 40 }}
            description={
              datos && datos.etapas.length === 0
                ? "Ninguna etapa lleva control por persona. Actívalo en Taxidermia → Etapas."
                : "Sin información para el periodo"
            }
          />
        ) : (
          <Tabs activeKey={this.state.tab} onChange={(tab) => this.setState({ tab })}>
            <TabPane tab="Resumen" key="resumen">
              {this.state.tab === "resumen" && this.renderResumen()}
            </TabPane>
            {datos.semanas.map((semana) => (
              <TabPane tab={semana.etiqueta} key={semana.clave}>
                {this.state.tab === semana.clave && (
                  <>
                    <div style={{ marginBottom: 10, color: "#555" }}>{textoSemana(semana)}</div>
                    {semana.secciones.map((seccion) => this.renderSeccion(seccion))}
                  </>
                )}
              </TabPane>
            ))}
          </Tabs>
        )}
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  empresaNombre: state.empresa.nombre,
});

export default connect(mapStateToProps)(ReporteProduccionSemanal);
